import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  user: {},
  errorMsg: '',
  userRole: null,
  userPermissions: [],
};

const authSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUser(state, action) {
      state.user = action.payload;
      const role = action.payload?.roles?.find((role) => {
        const { organizationId, brandId, storeId } =
          state.user?.dashboardSettings || {};
        if (storeId) {
          return (
            role?.organizationId === organizationId &&
            role?.brandId === brandId &&
            role?.storeId === storeId
          );
        } else if (brandId) {
          return (
            role?.organizationId === organizationId && role?.brandId === brandId
          );
        } else {
          return role?.organizationId === organizationId;
        }
      });
      state.userRole = role;
      const permissions = role?.permissions?.map((permission) => {
        return permission?.permissionId;
      });
      state.userPermissions = permissions;
    },
    setErrorMsg(state, action) {
      state.errorMsg = action?.payload;
    },
  },
});

export const { setUser, setErrorMsg } = authSlice.actions;
export default authSlice.reducer;
